import React from 'react';

export type MessageListContext = {
  showLoadMore: boolean;
  loadingOlder: boolean;
  onLoadMore: () => void;
};

// Virtuoso wraps Header in React.memo with no props and re-renders it only when
// its `context` prop changes identity — a Header reading component state through
// a closure renders once and then never again. So everything this needs arrives
// through context, and the owner gives that object a new identity exactly when
// one of its values changes.
// Virtuoso gates that Header re-render on `context` identity, so the identity has
// to be stable while the control looks the same and fresh the moment it changes.
// Too eager and the list churns; too sticky and the control never updates.
export const createListContextMemo = (onLoadMore: () => void) => {
  let previous: MessageListContext | null = null;

  return (showLoadMore: boolean, loadingOlder: boolean): MessageListContext => {
    if (
      previous !== null &&
      previous.showLoadMore === showLoadMore &&
      previous.loadingOlder === loadingOlder
    ) {
      return previous;
    }

    previous = { showLoadMore, loadingOlder, onLoadMore };

    return previous;
  };
};

const LoadOlderHeader = ({ context }: { context?: MessageListContext }) => {
  if (!context?.showLoadMore) {
    return null;
  }

  return (
    <div className="c-c-load-older">
      <button type="button" onClick={context.onLoadMore} disabled={context.loadingOlder}>
        {context.loadingOlder ? 'Loading...' : 'Load more'}
      </button>
    </div>
  );
};

export default LoadOlderHeader;
